import { Injectable } from "@angular/core";
import { IID_OL_RISPOSTA_SOLLECITO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolRispostaSollecitoStore } from "./iidOlRispostaSollecito.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.RISPOSTA_SOLLECITO)
export class IIDolRispostaSollecitoQuery extends AbstractInterfaceDataQuery<IID_OL_RISPOSTA_SOLLECITO> {
  constructor(protected store: IIDolRispostaSollecitoStore) {
    super(store);
  }
}
